export default {
	forms: {
		edit: {
			config: {
				fields: {
					id: {},
					region: {},
					code: {},
					name: {}
				}
			}
		},
		list: {
			config: {
				fields: {
					id: {
						config: {
							hide: true
						}
					},
					region: {},
					code: {},
					name: {}
				}
			}
		},
		select: {
			panel: {
				width: '80%'
			},
			config: {
				fields: {
					id: {
						config: {
							hide: true
						}
					},
					region: {},
					code: {},
					name: {}
				}
			}
		}
	}
}